import { classNames } from "@/utility/jsx";
import Logger from "@mm/logging";
import { Suspense, lazy } from "react";
import styles from "./ProfileWindowOverlay.module.scss";

const logger = Logger.fromFilename(__filename);
const ProfileOverlay = lazy(() =>
  import("@/overlay/overlays/profile")
    .then(({ ProfileOverlay }) => ({ default: ProfileOverlay }))
    .catch((error) => {
      logger.error("Loading profile overlay failed", error);
      return { default: () => <div>Loading overlay failed</div> };
    }),
);

export function ProfileWindowOverlay({ showNavigationHeader = true }: { showNavigationHeader?: boolean }) {
  return (
    <div className={classNames("gui-overlay", "overlay__layer", styles["profile-window-overlay"])}>
      <Suspense>
        <ProfileOverlay showNavigationHeader={showNavigationHeader} />
      </Suspense>
    </div>
  );
}
